var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_1835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 0.00012207H14.2576C13.6848 0.00012207 12.8842 0.331968 12.4794 0.736384L0.607952 12.6078C-0.20265 13.4175 -0.20265 14.745 0.607952 15.5537L9.44724 24.3927C10.256 25.2024 11.5822 25.2024 12.3922 24.3918L24.2637 12.5222C24.6681 12.1178 25 11.316 25 10.7444V2.08354C25 0.93792 24.0621 0.00012207 22.9166 0.00012207ZM18.7497 8.3335C17.599 8.3335 16.6662 7.39973 16.6662 6.25008C16.6662 5.09853 17.599 4.16666 18.7497 4.16666C19.9003 4.16666 20.8334 5.09853 20.8334 6.25008C20.8335 7.39973 19.9003 8.3335 18.7497 8.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_1835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Tag.d5560331.svg";
export { ForwardRef as ReactComponent };